import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartFunnelOnBehalfUserOptinItemBlockConfig } from '@front-platform/content-builder';
import { cartFunnelOnBehalfUserOptinItemBlockResolveConfig } from '@front-platform/content-builder';
import { take } from 'rxjs/operators';
import { Component, OnInit, input } from '@angular/core';

import { DoodCartFunnelValueTarget } from '@store/cart-funnel/cart-funnel.model';
import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
export interface CartFunnelOnBehalfUserOptinItemBlockRuntimeConfig {
  'block_id'?: string;
  'form_id'?: string;
}

export type CartFunnelOnBehalfUserOptinItemBlockConfigInput = Partial<
  Omit<
    CartFunnelOnBehalfUserOptinItemBlockConfig,
    keyof CartFunnelOnBehalfUserOptinItemBlockRuntimeConfig
  > &
    CartFunnelOnBehalfUserOptinItemBlockRuntimeConfig
>;
export type CartFunnelOnBehalfUserOptinItemBlockResolvedConfig = Omit<
  CartFunnelOnBehalfUserOptinItemBlockConfig,
  keyof CartFunnelOnBehalfUserOptinItemBlockRuntimeConfig
> &
  Partial<CartFunnelOnBehalfUserOptinItemBlockRuntimeConfig>;
export interface CartFunnelOnBehalfUserOptinItemBlockContract extends ConfigComponentContract<
  CartFunnelOnBehalfUserOptinItemBlockConfigInput,
  CartFunnelOnBehalfUserOptinItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-funnel-on-behalf-user-optin-item-block',
  templateUrl: './cart-funnel-on-behalf-user-optin-item-block.component.html',
  standalone: false,
})
export class CartFunnelOnBehalfUserOptinItemBlockComponent
  implements OnInit, CartFunnelOnBehalfUserOptinItemBlockContract
{
  readonly config = input<CartFunnelOnBehalfUserOptinItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartFunnelOnBehalfUserOptinItemBlockConfig,
    CartFunnelOnBehalfUserOptinItemBlockRuntimeConfig
  >(cartFunnelOnBehalfUserOptinItemBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get blockId(): string {
    return this.resolvedConfig()['block_id'] as unknown as string;
  }
  get formId(): string {
    return this.resolvedConfig()['form_id'] as unknown as string;
  }

  required = false;

  value = false;

  constructor(
    private cartFunnelSelector: CartFunnelStoreSelector,
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
  ) {}

  ngOnInit(): void {
    this.cartFunnelDispatcher.addValue({
      id: this.blockId,
      title: this.title,
      displayTitle: true,
      formId: this.formId,
      required: this.required,
      target: DoodCartFunnelValueTarget.OnBehalfUserOptin,
    });

    this.cartFunnelSelector
      .selectValue(this.blockId)
      .pipe(take(1))
      .subscribe(form => {
        this.value = Boolean(form?.value);
      });
  }

  onValueChange(_value: boolean): void {
    this.cartFunnelDispatcher.updateValue({
      id: this.blockId,
      changes: {
        value: _value,
      },
    });
  }

  forceType(data: any): any {
    return data as any;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartFunnelOnBehalfUserOptinItemBlockComponent, {
  'keyAliases': {},
});
